import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import * as _ from 'lodash';
import { DataSharingService } from 'projects/shared/src/lib/services/data-sharing.service';
import { AttributeValueService } from 'projects/shared/src/lib/services/attribute-value.service';
import { DocumentDto } from 'projects/shared/src/lib/models/DocumentDto';
import { ActivatedRoute } from '@angular/router';


// ------------ filepreview ---------------------------------
// https://stackblitz.com/edit/ngx-formly-ui-bootstrap-mcvzfp
// ----------------------------------------------------------

@Component({
  selector: 'al-file-upload-type',
  templateUrl: './al-file-upload-type.component.html',
  styleUrls: ['./al-file-upload-type.component.scss']
})
export class AlFileUploadTypeComponent extends FieldType implements OnInit {

  files: any[] = [];
  documentDto!: DocumentDto;

  totalRecords = 0;
  currentPage = 1;
  pageSize = 10

  dbName!: string;
  pageId!: string;
  documentId!: string;

  constructor(private route: ActivatedRoute,
    private dataSharingService: DataSharingService,
    private attributeValueService: AttributeValueService) {
    super();
  }

  override ngOnInit(): void {
    this.dbName = localStorage.getItem('dbname') as string;

    this.dataSharingService.tabIdChanges$.subscribe({
      next: (pageId:any) => {
        this.pageId = pageId as string;
      }
    });

    this.documentId = localStorage.getItem('doc-id') as string;
    this.pageId = localStorage.getItem('page-id') as string;

    this.attributeValueService.loadCurrentAttributeValue('', this.documentId, this.pageId, this.currentPage, this.pageSize, this.dbName).subscribe({
      next: (currentAttributeValueDto:any) => {
        JSON.parse(currentAttributeValueDto.controlData);
      },
      //error: error => this.errorMessage = ErrorFormat.formatError(error)
    })
  }

  /**
   * on file drop handler
   */
  onFileDropped(event: any) {
    this.prepareFilesList(event);

  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(key: any, id: any, files: any) {
    // this.prepareFilesList(files.target.files);

    let formData: any = {};

    _.forEach(files.target.files, (file => {

      formData[key] = file.name;
      formData['size'] = file.size;
      formData['type'] = file.type;

      //formData = {key:file.name, 'size':file.size, 'type':file.type};
      this.attributeValueService.createAttributValueInfo(this.documentId, this.pageId, formData, key, id, this.dbName).subscribe({
        next: (data:any) => {
          this.prepareFilesList(files.target.files);
          console.log(data)
        },
        // error: error => this.errorMessage = ErrorFormat.formatError(error)
      })
    }))
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: any, decimals: any) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
